import _ from 'lodash';
import React, { PureComponent } from 'react';
import Template from './_internal/Template';
import Image from './Image';
import Heading from './Heading';
import { Carousel } from '@eb/eds-carousel';
import {
    HEADING_PROP_TYPES,
    IMAGE_PROP_TYPES,
    TEMPLATE_PROP_TYPES,
    TEMPLATE_PROPS,
    TESTIMONIALS_PROP_TYPES,
} from '../constants/componentPropTypes';

import './testimonials.scss';

const ITEMS_PER_SLIDE = 3;

const Testimonial = ({ imagePath, quote, byline }) => (
    <div className="eds-g-cell eds-l-pad-hor-4 eds-g-cell-1-1 eds-g-cell-mn-1-3">
        <figure className="marketing-image--logo eds-align--center eds-l-pad-vert-2">
            <Image imagePath={imagePath} />
        </figure>
        <p className="marketing-default-text eds-text--center eds-text-bm">
            {quote}
        </p>
        <p className="marketing-default-text eds-text--center eds-text-weight--heavy eds-l-pad-top-4">
            {byline}
        </p>
    </div>
);

const _getTestimonials = (testimonials) => {
    let testimonialsList = null;

    if (testimonials) {
        testimonialsList = testimonials.map(({ imagePath, quote, byline }) => (
            <Testimonial
                key={imagePath}
                imagePath={imagePath}
                quote={quote}
                byline={byline}
            />
        ));
    }

    return testimonialsList;
};

export default class Testimonials extends PureComponent {
    static propTypes = {
        ...TEMPLATE_PROP_TYPES,
        ...IMAGE_PROP_TYPES,
        ...TESTIMONIALS_PROP_TYPES,
        ...HEADING_PROP_TYPES,
    };

    render() {
        const { heading, testimonials } = this.props;

        if (!heading || !testimonials) {
            return null;
        }

        const testimonialsList = _getTestimonials(testimonials);
        const templateProps = _.pick(this.props, TEMPLATE_PROPS);

        return (
            <div className="eds-g-grid">
                <Template
                    {...templateProps}
                    hasPadding={true}
                    useBaseline={true}
                >
                    <div className="eds-g-cell eds-g-cell-10-12 eds-g-cell-md-6-12 eds-g-offset-1-12 eds-g-offset-md-3-12 eds-text--center">
                        <Heading
                            heading={heading}
                            useSmallFont={true}
                            alignCenter={true}
                            removeHorizontalPadding={true}
                        />
                    </div>
                    <section className="eds-l-pad-bot-10">
                        <Carousel itemsPerSlide={ITEMS_PER_SLIDE}>
                            {testimonialsList}
                        </Carousel>
                    </section>
                </Template>
            </div>
        );
    }
}
